<template>
  <div class="_flex:column _flex:align(center)" style="max-width: 24rem;">
    <ds ds="icon" name="verified" color="var(--success)" size="4rem" class="_m:y(4)" />
    <h1 class="h3" style="color: var(--success)">{{ $t('view.ConfirmSignUp.title') }}</h1>
    <h2 class="_text:sm _text(400) _m:bottom(4) _align:center">{{ $t('view.ConfirmSignUp.desc') }}: <br /> <b>{{ email }}</b></h2>
    <ds ds="form"
      id="confirm-sign-up"
      @valid="e => isValid = e.detail"
      @submit="submitConfirmSignUp"
    >
      <ds ds="input-string"
        name="code"
        :label="$t('shared.label.code')"
        type="text"
        :value.sync="code"
        :validate="v => ds.vMinLength(6)(v) || ds.vAlphaNumeric(v)"
        class="_m:bottom(3)"
      />

      <ds ds="button"
        id="confirm-sign-up"
        :label="$t('view.ConfirmSignUp.action')"
        version="primary"
        type="submit"
        :isLoading="isLoading"
        class="_m:y(3)"
      />
      <ds ds="button"
        id="resend-code"
        :label="$t('view.ConfirmSignUp.resendCode.action')"
        mode="text"
        @click="resendCode"
      />
      <ds ds="button"
        id="sign-up"
        :label="$t('view.ConfirmSignUp.goBack')"
        mode="text"
        @click="$router.push({ name: 'sign-up' })"
        class="auth-footer"
      />
    </ds>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus';
import { mapGetters } from 'vuex';
import { LoggerService } from '@/services';
import { authHelper } from '@/mixins';
import { authGuard } from '@tokenyico/vuejs-toolkit/src/exports/mixins/guards';

export default {
  name: 'ConfirmSignUp',
  mixins: [authHelper, authGuard({ name: 'appIndex' })],
  data: () => ({
    code: '',
    email: '',
    isLoading: true,
    isValid: false
  }),
  computed: {
    windowTitle () {
      return this.$t('view.ConfirmSignUp.title');
    }
  },
  methods: {
    ...mapGetters({
      userEmail: 'qualification/userEmail'
    }),
    async submitConfirmSignUp () {
      eventBus.$emit('isSubmitting', true);
      this.isLoading = true;
      try {
        await this.confirmSignUp({
          username: this.email,
          code: this.code
        });
        LoggerService.success(this.$t('view.ConfirmSignUp.successMessage'));
        this.$router.push({ name: 'sign-in' });
      } catch (error) {
        if (error.code === 'NotAuthorizedException') {
          LoggerService.error(error); // "Account already verified - please sign in"
          this.$router.push({ name: 'sign-in' });
        } else {
          LoggerService.error(error);
        }
      }
      this.isLoading = false;
      eventBus.$emit('isSubmitting', false);
    },
    async resendCode () {
      try {
        await this.resendSignUp({ username: this.email });
        LoggerService.success(this.$t('view.SignUp.successMessage'));
      } catch (error) {
        LoggerService.error(error);
      }
    }
  },
  async mounted () {
    this.isLoading = true;
    const query = new URLSearchParams(location.search);
    if (query.get('email')) {
      this.email = query.get('email');
      this.code = query.get('code');
    } else if (this.userEmail()) {
      this.email = this.userEmail();
    }

    if (!this.email) {
      this.$router.push({ name: 'sign-up' });
    }

    this.isLoading = false;
  }
};
</script>

<style lang="less" scoped>
.btn + .btn {
  margin-left: 0;
  width: 100%;
}
</style>
